
import { defineComponent } from 'vue'
import AppResumeComponent from '@/components/AppResumeComponent.vue'
import AppInfoTitles from '@/components/AppInfoTitles.vue'
import AppButtonResetNav from '@/components/buttons/AppButtonResetNav.vue'
import { useStore } from 'vuex'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'

export default defineComponent({
  components: {
    AppResumeComponent,
    AppInfoTitles,
    AppButtonResetNav
  },
  setup() {
    const { state } = useStore<VuexStore>(key)

    return {
      state
    }
  }
})
